import { render, staticRenderFns } from "./TableColumns.vue?vue&type=template&id=1029b0a8&scoped=true"
import script from "./TableColumns.vue?vue&type=script&lang=js"
export * from "./TableColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1029b0a8",
  null
  
)

export default component.exports